/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Feedback_CollectedInputs */

const cs_enum_feedback_collected = /** @type {(inputs: Enum_Feedback_CollectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zpětná vazba`)
};

const en_enum_feedback_collected = /** @type {(inputs: Enum_Feedback_CollectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback collected`)
};

/**
* | output |
* | --- |
* | "Feedback collected" |
*
* @param {Enum_Feedback_CollectedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_feedback_collected = /** @type {((inputs?: Enum_Feedback_CollectedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Feedback_CollectedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_feedback_collected(inputs)
	return cs_enum_feedback_collected(inputs)
});